var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Image } from '../Image';
var RandomImage = styled(Image)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", "px;\n  width: ", "px;\n"], ["\n  height: ", "px;\n  width: ", "px;\n"])), function (props) { return props.height; }, function (props) { return props.width; });
var determineSRC = function (blur, chooseSrc, height, width) {
    var imageURLs = [
        "http://placeimg.com/".concat(width, "/").concat(height, "/any"),
        "http://placekitten.com/".concat(width, "/").concat(height),
        "https://picsum.photos/".concat(width, "/").concat(height),
        "https://source.unsplash.com/".concat(width, "x").concat(height),
        "https://www.fillmurray.com/".concat(width, "/").concat(height),
    ];
    if (blur || chooseSrc) {
        return blur ? "https://picsum.photos/".concat(width, "/").concat(height, "?blur") : imageURLs[chooseSrc];
    }
    var randomNum = Math.floor(Math.random() * imageURLs.length);
    return imageURLs[randomNum];
};
var propTypes = {
    ariaHidden: PropTypes.bool,
    blur: PropTypes.bool,
    chooseSrc: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};
var PlaceholderImage = function (props) {
    var alt = props.alt, ariaHidden = props.ariaHidden, blur = props.blur, chooseSrc = props.chooseSrc, className = props.className, height = props.height, width = props.width;
    return (React.createElement(RandomImage, { alt: alt || 'Random image used for placeholder content', "aria-hidden": ariaHidden, blur: blur, className: className, height: height, src: determineSRC(blur, chooseSrc, height, width), width: width }));
};
PlaceholderImage.displayName = 'PlaceholderImage';
PlaceholderImage.propTypes = propTypes;
PlaceholderImage.defaultProps = {
    ariaHidden: true,
    blur: false,
    height: '500',
    width: '500',
};
export default PlaceholderImage;
var templateObject_1;
//# sourceMappingURL=PlaceholderImage.js.map